import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=ad942fde&scoped=true&"
var script = {}
import style0 from "./NotFoundPage.vue?vue&type=style&index=0&id=ad942fde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad942fde",
  null
  
)

export default component.exports